import { render } from "./ScoreButton.vue?vue&type=template&id=2a1d688e&scoped=true"
import script from "./ScoreButton.vue?vue&type=script&lang=js"
export * from "./ScoreButton.vue?vue&type=script&lang=js"

import "./ScoreButton.vue?vue&type=style&index=0&id=2a1d688e&scoped=true&lang=css"

import exportComponent from "/home/lbecker/git/usssa-score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1d688e"]])

export default __exports__